import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listPermisos:[],
  newPermiso:[]
};
export const mutations = {
  GET_PERMISOS({ context }, permisos) {
    state.listPermisos = Object.assign({}, permisos);
  },

  SAVE_PERMISO({ context }, permiso) {
    state.newPermiso = Object.assign({}, permiso);
  },
  EDIT_PERMISO({ context }, dataPermiso) {
    state.dataPermiso = Object.assign({}, dataPermiso);
  },
};
export const actions = {
  GET_PERMISOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_PERMISOS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_PERMISO({ commit }, permiso) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(permiso)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_PERMISO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_PERMISO({ commit }, dataPermiso) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataPermiso)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_PERMISO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_PERMISO({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};

export const getters = {//leer datos
  listPermisos: state => state.listPermisos,
  newPermiso: state => state.newPermiso
};
